import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-icon-sprite',
    standalone: true,
    templateUrl: './icon-sprite.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSpriteComponent {}
